<template>
  <div class="main">
    <img class="pic" src="@/assets/img/framework.jpg" />
    <img class="treePic" src="@/assets/img/tree.png" />
    <!-- <img class="title_left" src="@/assets/img/tree_title.png" /> -->
    <div class="tree" v-if="playTree">
      <div>
        <div class="fruit" :class="isSmallScreen ? 'small' : ''">
          <div class="fruitTop">
            <div class="fruitItem"><span>公交</span></div>
            <div class="fruitItem tobottom"><span>交通</span></div>
          </div>
          <div class="fruitI2">
            <div class="left">
              <div class="fruitItem totop"><span>社区</span></div>
              <div class="fruitItem toleft"><span>档案</span></div>
            </div>
            <div class="right">
              <div class="fruitItem tobottom"><span>教育</span></div>
              <div class="fruitItem"><span>环保</span></div>
            </div>
          </div>
          <div class="fruitI3">
            <div class="left">
              <div class="fruitItem more">
                <span>资产<br />管理</span>
              </div>
              <div class="fruitItem totop"><span>税务</span></div>
              <div class="fruitItem more tobottom">
                <span>楼宇<br />经济</span>
              </div>
            </div>
            <div class="right">
              <div class="fruitItem toright"><span>安监</span></div>
              <div class="fruitItem"><span>城管</span></div>
              <div class="fruitItem tobottom toleft"><span>管线</span></div>
            </div>
          </div>
          <div class="fruitI4">
            <div class="left">
              <div class="fruitItem"><span>国土</span></div>
              <div class="fruitItem"><span>规划</span></div>
            </div>
            <div class="right">
              <div class="fruitItem"><span>电力</span></div>
              <div class="fruitItem toright"><span>燃气</span></div>
            </div>
          </div>
          <div class="fruitBottom">
            <div class="fruitItem"><span>房产</span></div>
            <div class="fruitItem"><span>水务</span></div>
          </div>
        </div>
      </div>

      <div class="treeCenter">
        <span v-if="$store.state.language == 'Chinese'">智能<br />中枢</span>
        <span class="englishBase" v-else>Intelligent Center</span>
      </div>
      <div class="base" v-if="$store.state.language == 'Chinese'">
        <div class="baseItem baseItem1"><span>地理库</span></div>
        <div class="baseItem baseItem2"><span>法人库</span></div>
        <div class="baseItem baseItem3"><span>人口库</span></div>
        <div class="baseItem baseItem4"><span>信用库</span></div>
        <div class="baseItem baseItem5"><span>证照库</span></div>
        <div class="baseItem baseItem6"><span>经济库</span></div>
      </div>
      <div class="base englishBase" v-else>
        <div class="baseItem baseItem1"><span>Geographic Database</span></div>
        <div class="baseItem baseItem2"><span>Corporate Database</span></div>
        <div class="baseItem baseItem3"><span>Population Database</span></div>
        <div class="baseItem baseItem4"><span>Credit Database</span></div>
        <div class="baseItem baseItem5"><span>License Database</span></div>
        <div class="baseItem baseItem6"><span>Economic Database</span></div>
      </div>
    </div>
    <!-- <div class="box">
      <span class="lineAnima"></span>
      <span class="lineAnima"></span>
      <span class="lineAnima"></span>
      <span class="lineAnima"></span>
      <span class="lineAnima"></span>
      <span class="lineAnima"></span>
      <span class="lineAnima"></span>
      <span class="lineAnima"></span>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "Tree",
  props: {
    playTree: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fruits: [],
      baseItem: [],
      isSmallScreen: false,
    };
  },
  mounted() {
    if (window.innerHeight < 595) {
      this.isSmallScreen = true;
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "../../assets/customAnimation.css";
.main {
  position: relative;
  width: 100vw;
  height: 100%;
  // overflow: hidden;
  img {
    // width: 1600px;
    width: 100%;
    // margin-top: 130px;
    margin-top: -120px;
  }
  .pic {
    height: 100vh;
    margin-top: 0;
  }
  .treePic {
    width: 80%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -12%;
  }
  .title_left {
    width: 97px;
    position: absolute;
    left: 150px;
    top: 150px;
    margin: 0;
  }
}
.tree {
  position: absolute;
  left: 50%;
  bottom: 0;
  .fruit,
  .base,
  .treeCenter {
    display: flex;
    transform: translateX(-50%);
  }
  .fruit {
    position: absolute;
    // bottom: 380px;
    bottom: 360px;
    > div {
      position: absolute;
      display: flex;
      .tobottom {
        position: relative;
        top: 20px;
      }
      .totop {
        position: relative;
        top: -20px;
      }
      .toleft {
        position: relative;
        left: -20px;
      }
      .toright {
        position: relative;
        left: 20px;
      }
    }
    .fruitBottom {
      left: -400px;
      width: 800px;
      justify-content: space-between;
    }
    .fruitI4 {
      bottom: 50px;
      left: -550px;
      width: 1000px;
      justify-content: space-between;
    }
    .fruitI3 {
      bottom: 150px;
      left: -450px;
      width: 900px;
      justify-content: space-between;
      .left,
      .right {
        .fruitItem {
          margin: 0 30px;
          animation-name: showFruit, moveFruit;
          animation-duration: 2s, 3s;
          animation-delay: 0.6s, 1.1s;
          animation-iteration-count: 1, infinite;
        }
      }
    }
    .fruitI2 {
      bottom: 240px;
      left: -300px;
      width: 600px;
      justify-content: space-between;
    }
    .fruitTop {
      bottom: 320px;
      left: -100px;
      width: 200px;
      justify-content: space-between;
    }
    .left,
    .right {
      display: flex;
      .fruitItem {
        margin: 0 50px;
        animation-name: showFruit, moveFruit;
        animation-duration: 3s, 5s;
        animation-delay: 0.5s, 0.8s;
        animation-iteration-count: 1, infinite;
      }
    }
    .fruitItem {
      width: 60px;
      height: 60px;
      background: url(../../assets/img/round.png) no-repeat center;
      background-size: cover;
      // 动画
      // animation: moveFruit 4s linear infinite;
      animation-name: showFruit, moveFruit;
      animation-duration: 2s, 4s;
      animation-delay: 0.9s, 1.3s;
      animation-iteration-count: 1, infinite;
      span {
        color: #fff;
        font-size: 18px;
        line-height: 60px;
      }
    }
    .more {
      span {
        position: relative;
        top: 10px;
        line-height: 20px;
      }
    }
  }
  .small {
    .fruitBottom {
      bottom: -30px;
    }
    .fruitI3 {
      bottom: 130px;
    }
    .fruitI2 {
      bottom: 220px;
    }
    .fruitTop {
      bottom: 290px;
    }
  }
  .treeCenter {
    position: absolute;
    //  bottom: 250px;
    bottom: 260px;
    left: -3px;
    span {
      color: #fff;
      font-weight: bold;
      font-size: 20px;
      writing-mode: vertical-lr;
    }
  }
  .base {
    position: absolute;
    // bottom: 70px;
    bottom: 20px;
    .baseItem {
      height: 145px;
      width: 94px;
      background: url(../../assets/img/base.png) no-repeat center;
      background-size: cover;
      position: relative;
      animation: display 3s linear infinite;
      span {
        color: #fff;
        font-size: 18px;
        writing-mode: vertical-lr;
        margin-top: 30px;
      }
    }
    .baseItem1,
    .baseItem6 {
      top: -100px;
      animation: fromBottom1 1.5s ease-in-out;
    }
    .baseItem2,
    .baseItem5 {
      top: -50px;
      animation: fromBottom2 2s ease-in-out;
    }
    .baseItem3,
    .baseItem4 {
      margin: 0 50px;
      animation: fromBottom 2s ease-in-out;
    }
  }
  .englishBase {
    writing-mode: horizontal-tb !important;
    .baseItem {
      span {
        position: relative;
        top: 20px;
        writing-mode: horizontal-tb;
      }
    }
  }
}
// 流星动画
// .box {
//   position: absolute;
//   top: 0;
//   left: 0;
//   // 绝对定位
//   width: 100%;
//   height: 100vh;
//   transform: translateX(-35%);
// }
// .lineAnima {
//   position: absolute;
//   top: 0;
//   left: 0;
//   // 绝对定位
//   width: 4px;
//   height: 4px;
//   // 宽高
//   background: #ffffff;
//   // 白色背景
//   border-radius: 50%;
//   // 边框圆角
//   box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.1),
//     0 0 0 4px rgba(255, 255, 255, 0.1), 0 0 20px rgba(255, 255, 255, 1);
//   // 盒子阴影
// }
// .lineAnima::before {
//   content: "";
//   position: absolute;
//   top: 25%;
//   // transform: translateX(0);
//   // 位置偏移 x轴,用于调整光点位置
//   width: 200px;
//   height: 2px;
//   background: linear-gradient(
//     90deg,
//     #fcfdff,
//     rgba(251, 70, 155, 0.5),
//     transparent
//   );
//   filter: blur(1px);
//   // 创建一个表示两种或多种颜色线性渐变的图片
// }

// @for $i from 1 through 185 {
//   .lineAnima:nth-child(#{$i}) {
//     top: #{random(700)}px;
//     right: #{random(520)}px;
//     // random() 随机数 700相当于700以内的随机整数
//     left: initial;
//     // 因为同时设置left  和 right的话，left的权重比较高，此时right不生效。所以把left设置为initial，恢复为默认的样式，此时再设置right的值就会生效了。
//     animation: lineanimate
//       #{random(2) +
//       random()}s
//       linear
//       #{random()}s
//       infinite;
//     //  添加动画
//   }
// }

// @keyframes lineanimate {
//   0% {
//     transform: rotate(-90deg) translateX(0);
//     // 旋转加偏移
//     opacity: 1;
//     // 透明度 值为0-1
//   }
//   70% {
//     opacity: 1;
//   }
//   100% {
//     transform: rotate(-90deg) translateX(-1000px);
//     opacity: 0;
//   }
// }
</style>
